import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';

// Auth pages (no layout)
import { LoginPage }    from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';

// App pages (inside AppLayout)
import { DashboardPage }     from './pages/DashboardPage';
import { IngestionPage }     from './pages/IngestionPage';
import { InboxPage }         from './pages/InboxPage';
import { LibraryPage }       from './pages/LibraryPage';
import { GraphPage }         from './pages/GraphPage';
import { AnalystPage }       from './pages/AnalystPage';
import { ReportBuilderPage } from './pages/ReportBuilderPage';
import { PublishPage }       from './pages/PublishPage';
import { SettingsPage }      from './pages/SettingsPage';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login"    element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Protected routes — inside AppLayout */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Routes>
                      <Route path="dashboard"     element={<DashboardPage />} />
                      <Route path="ingest"        element={<IngestionPage />} />
                      <Route path="inbox"         element={<InboxPage />} />
                      <Route path="library"       element={<LibraryPage />} />
                      <Route path="graph"         element={<GraphPage />} />
                      <Route path="analyst"       element={<AnalystPage />} />
                      <Route path="report"        element={<ReportBuilderPage />} />
                      <Route path="publish/:articleId" element={<PublishPage />} />
                      <Route path="settings"      element={<SettingsPage />} />
                      <Route path="*"             element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                  </AppLayout>
                </ProtectedRoute>
              }
            />

            {/* Root redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export { App };
